import { makeStyles, withStyles } from '@material-ui/core/styles';
import TableRow from '@material-ui/core/TableRow';
import TableCell from '@material-ui/core/TableCell';
import TableSortLabel from '@material-ui/core/TableSortLabel';
import clsx from 'clsx';

const useStyles = makeStyles((theme) => ({
  heading: (props) => ({
    backgroundColor: theme.palette.primary.main,
    color: theme.palette.common.white,
    borderBottom: 'none',
    padding: '6px 10px',
    '&:first-child': {
      borderLeft: '2px solid #3f4e5c'
    },
    '&:last-child': {
      borderRight:'2px solid #3f4e5c'
    }
  }),
  combined: {
    comibined: clsx('heading', 'body1'),
  },

  icon: {
    color: '#fff',
    border: 'solid red 1px'
  },
  visuallyHidden: {
    border: 0,
    clip: 'rect(0 0 0 0)',
    height: 1,
    margin: -1,
    overflow: 'hidden',
    padding: 0,
    position: 'absolute',
    top: 20,
    width: 1,
  },
  sortLabel: {
    color: '#ffff', // set the default color
    '&:hover': {
      color: '#ffff', // change the color on hover
    },
    '&$active': {
      color: '#ffff', // change the label color when active
      '& $icon': {
        color: '', // change the arrow icon color when active
      },
    },
    '&$focusVisible': {
      color: '#ffff', // change the color on focus
    },
  },
  active: {},
  icon: {
    color: '#ffff',
  },
  activeIcon: {
    '&$active': {
      color: '#ffff', // change the label color when active
      '& $icon': {
        color: '', // change the arrow icon color when active
      },
    },
  },
}));




export const StyledTableCell = withStyles((theme) => ({
  head: {
    backgroundColor: theme.palette.primary.main,
    color: theme.palette.common.white,
  },
  body: {
    fontSize: 14,
    padding: '6px 10px',
    '&:first-child': {
      borderLeft: "2px solid rgba(224, 224, 224, 1)"
    },
    '&:last-child': {
      borderRight: "2px solid rgba(224, 224, 224, 1)"
    }
  },
}))(TableCell);


export const StyledTableCellHead = (props) => {

  const classes = useStyles();

  const handleRequestSort = (event, property) => {
    const isAsc = props.orderBy === property && props.order === 'asc';
    props?.setOrder(isAsc ? 'desc' : 'asc');
    props?.setOrderBy(property);
  };

  const createSortHandler = (property) => (event) => {
    handleRequestSort(event, property);
  };

  return (
    <TableCell className={`${classes.heading}`} align={props.align} sortDirection={props?.orderBy === props?.sortName ? props.order : false} style={props.style}>
      {props?.orderBy != undefined && props?.order != undefined && <TableSortLabel
        classes={{
          root: classes.sortLabel,
          active: classes.active,
          icon: clsx(
            classes.activeIcon,
            // (props.orderBy === props.sortName) && classes.active, // add the active class if the component is active
          ),
        }}
        active={props.orderBy === props.sortName}
        direction={props.orderBy === props.sortName ? props.order : 'asc'}
        onClick={createSortHandler(props.sortName)}
      >
        {props.children}
      </TableSortLabel>}
      {props?.orderBy == undefined && props?.order == undefined && <>{props.children}</>}
    </TableCell>
  )
}


export const StyledTableRow = withStyles((theme) => ({
  root: {
    '&:nth-of-type(odd)': {
      backgroundColor: theme.palette.action.hover,
    },

    /* Hide actions by default */
    '& .row-actions': {
      opacity: 0,
      visibility: 'hidden',
    },

    /* Show ONLY on row hover */
    '&:hover .row-actions': {
      opacity: 1,
      visibility: 'visible',
    },
  },
  clickable: {
    cursor: 'pointer',
  },
  selected: {},
}))(TableRow);


